import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../lib/api.js';
import { setKey, setUser } from '../lib/auth.jsx';

export default function PasswordReset() {
  const [search] = useSearchParams();
  const token = search.get('token') || '';
  const email = search.get('email') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (password !== confirm) { setErr('Passwords do not match.'); return; }
    if (password.length < 8) { setErr('Password must be at least 8 characters.'); return; }
    setBusy(true);
    try {
      const r = await api.confirmPasswordReset({ token, email, new_password: password });
      if (r?.access_key) setKey(r.access_key);
      if (r?.user) setUser(r.user);
      nav('/dashboard', { replace: true });
    } catch (e) {
      setErr(e?.data?.detail || e?.data?.error || e.message || 'Reset failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy via-navy-700 to-navy-800 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-2xl p-8">
        <Link to="/" className="block mb-6 text-center">
          <span className="font-bold text-navy">MAPTRIUM™</span>
        </Link>
        <h1 className="text-2xl font-bold text-navy mb-2">Set a new password</h1>
        <p className="text-sm text-ink-muted mb-4">For account <strong>{email || '(missing email)'}</strong>.</p>
        {!token || !email ? (
          <div className="text-sm text-red-600">This reset link is missing required parameters. Request a new link from the sign-in page.</div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input type="password" required minLength={8} placeholder="New password (8+ chars)"
              className="input" value={password} onChange={e => setPassword(e.target.value)} />
            <input type="password" required minLength={8} placeholder="Confirm new password"
              className="input" value={confirm} onChange={e => setConfirm(e.target.value)} />
            {err && <div className="text-sm text-red-600">{err}</div>}
            <button className="btn btn-primary w-full" disabled={busy || !password || !confirm}>
              {busy ? 'Saving…' : 'Set password & sign in'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
